import {useRouter} from 'next/router'
import {useMemo} from 'react'

import {CONNECT_SCHEME} from '@mydata/utils/connect'
import NURL from '@naverpay/nurl'

import {EXTERNAL_ROUTES} from '$constants/external-routes'
import {useUserInfoContext} from '$contexts/member/userInfoStatus'
import {useNewConnectionUrl} from '$hooks/useConnectUrl'
import CONFIG, {BASE_PATH} from '$share/config'
import baseOrigin from '$utils/baseOrigin'

export function useNewTabHooks() {
    const {
        userInfo: {isLogin},
    } = useUserInfoContext()
    const router = useRouter()

    const {connectUrl} = useNewConnectionUrl({scheme: CONNECT_SCHEME.MYDATA_INSURANCE})

    const url = useMemo(() => {
        const parsedQuery = router.query ? Object.fromEntries(new Map(Object.entries(router.query))) : undefined

        return new NURL({
            baseUrl: baseOrigin,
            pathname: `${BASE_PATH}${router.pathname}`,
            ...(parsedQuery ? {parsedQuery} : {}),
        }).href
    }, [router.pathname, router.query])

    const href = useMemo(
        () =>
            isLogin
                ? connectUrl
                : new NURL({
                      baseUrl: CONFIG.URL.NID,
                      pathname: EXTERNAL_ROUTES.NID.LOGIN,
                      query: {
                          url,
                      },
                  }).href,
        [connectUrl, isLogin, url],
    )

    return useMemo(
        () => ({
            href,
            targetProps: isLogin ? {target: '_blank'} : {},
        }),
        [href, isLogin],
    )
}
